<template>
    <div style="height: 100%;">
        <iframe :src="instruction" width="100%" style="height: 93vh;" allowfullscreen frameborder="0"></iframe>
    </div>
</template>

<script>

export default {
    name: 'Instruction',

    props: [
    ],

    data() {
        return {
            instruction: this.$route.params.id
        }
    },

    methods: {

    }
}
</script>